import Konva from 'konva/konva'

const size = 16
const offset = 10
const handleBorder = { color: 'Grey', width: 1, radius: 3 }
const handleBackground = 'rgba(255,255,255,0.7)'
const arrowShape = { offset: { x: 4, y: 3 }, split: 4 }
const arrowLine = { color: 'Grey', width: 1 }

export default class ResizeHandle extends Konva.Group {
  constructor ({ yOffsetBottom, minDiff, resizeHandler }) {
    super({
      x: offset,
      y: yOffsetBottom - handleBorder.width - size,
      draggable: true,
      dragBoundFunc: ({ y }) => ({
        x: this.getAbsolutePosition().x, // vertical movement only
        y: this.dragStartY ? Math.max(y, this.dragStartY + minDiff) : y // limit top by var's min height
      })
    })
    Object.assign(this, { resizeHandler })

    this._render()

    this.on('mouseover', this._OnMouseOver)
    this.on('mouseout', this._OnMouseOut)
    this.on('dragstart', this._onDragStart)
    this.on('dragend', this._onDragEnd)
  }

  _render () {
    const handle = new Konva.Rect({
      x: 0,
      y: 0,
      width: size,
      height: size,
      stroke: handleBorder.color,
      strokeWidth: handleBorder.width,
      cornerRadius: handleBorder.radius,
      fill: handleBackground
    })
    const upArrowPoints = [
      arrowShape.offset.x, (size - arrowShape.split) / 2,
      size / 2, arrowShape.offset.y,
      size - arrowShape.offset.x, (size - arrowShape.split) / 2
    ]
    const downArrowPoints = [
      arrowShape.offset.x, (size + arrowShape.split) / 2,
      size / 2, size - arrowShape.offset.y,
      size - arrowShape.offset.x, (size + arrowShape.split) / 2
    ]
    const lines = [upArrowPoints, downArrowPoints]
      .map(points => new Konva.Line({
        points,
        stroke: arrowLine.color,
        strokeWidth: arrowLine.width
      }))

    const shapes = [handle, ...lines]
    shapes.forEach(shape => this.add(shape))
  }

  _OnMouseOver () {
    document.body.style.cursor = 'pointer'
  }

  _OnMouseOut () {
    document.body.style.cursor = 'default'
  }

  _onDragStart (event) {
    event.cancelBubble = true
    this.dragStartY = this.y()
  }

  _onDragEnd (event) {
    event.cancelBubble = true
    this._OnMouseOut()
    const diff = this.y() - this.dragStartY
    this.resizeHandler(diff)
  }
}
